import React, { useState, useEffect } from 'react';
import {FormComponent} from '@formbird/types';
import { convertToCustomElement } from '../utils/CustomElementWrapper';

const CrmNavBarDropMenuRow = ({name, icon, url}) => {
  return <li>
    <a href={url}>
      <i class={'fa ' + icon} style={{margin: "0 5px"}}/>
      {name}
    </a>
  </li>
}

const CrmNavBarDropMenu = ({data}) => {
  const {title, icon, rows} = data;

  return <div class='btn-group' role='group'>
    <button class='btn btn-default btn-lg dropdown-toggle' type='button' data-toggle='dropdown' id={'dropdownMenu'+title} aria-haspopup='true' aria-expanded='true'>
        <i class={'fa '+icon} style={{margin: "0 5px"}}></i>
        {title}
    </button>
    <ul class='dropdown-menu' aria-labelledby={'dropdownMenu'+title}>
      {rows.map( row => <CrmNavBarDropMenuRow {...row} /> )}
    </ul>
  </div>
}

const CrmNavBarComponent = ({componentDefinition}) => {
  const data = componentDefinition.nav == undefined ? [] : componentDefinition.nav;

  return (
    <div class='btn-group' role='group'>
      {data.map( row => <CrmNavBarDropMenu data={row} /> )}
    </div>
  );
};

// register the component as a custom element so it can be shown in formbird
convertToCustomElement('crm-nav-bar', CrmNavBarComponent);

export default CrmNavBarComponent;
